<div
  [cdkDragFreeDragPosition]="dragPosition"
  class="box-modal d-flex flex-column"
  cdkDrag
  (window:resize)="onResize($event)"
  [ngClass]="options?.PanelClass ? options?.PanelClass : null"
  *ngIf="!options?.isMinimized"
  #divWindow
  style="max-width:280px;"
>
  <div class="d-flex flex-column justify-content-between align-items-stretch flex-fill">
    <div class="box-modal-header d-flex justify-content-between align-items-center gap-3" cdkDragHandle>
      <ng-content select="[header]"></ng-content>

      <div *ngIf="options?.Header?.VisibleTitle !== false" class="d-flex justify-content-start align-items-center gap-2">
        {{ options?.Header?.Title }}
      </div>

      <!-- Contêiner para todos os ícones -->
      <div class="d-flex gap-3 icons-container">
        <div *ngIf="options.VisibleMini && !options?.Header?.Maximized">
          <mat-icon (click)="onCancel('Minimize')">minimize</mat-icon>
        </div>

        <div *ngIf="!options.VisibleMini && !options?.Header?.Maximized">
          <mat-icon (click)="onCancel('Close')" mat-dialog-close>close</mat-icon>
        </div>
      </div>
    </div>

    <div class="box-modal-body d-flex flex-column align-items-stretch" style="padding: 0px;width:100%; margin: 0px;">
        <ng-content select="[content]"></ng-content>
    </div>
    <!-- <ng-content *ngIf="options?.Footer?.Visible == false" select="[footer]" id="footer"></ng-content> -->

    <div class="box-modal-footer" cdkDragHandle *ngIf="options?.Footer?.Visible !== false" style="width:100%; margin: 0px;">

      <!-- <div class=" "> -->
        <div class="d-flex row" style="width: 100%; margin: 0px;">
          <div class="col" style="padding: 0px;">
            <button mat-icon-button type="button" [disabled]="okButtonDisabled"
                    [mat-dialog-close]="data" (click)="onOk()"
                    *ngIf="options?.Footer?.ShowOk !== false"
                    style="padding: 0px; height: 40px; width: 40px;">
              <mat-icon style="margin-top: -4px; margin-left: -4px;">check</mat-icon>
            </button>
          </div>

          <!-- Edit Button -->
          <div class="col" style="padding: 0px;">
            <button mat-icon-button type="button"
                    (click)="onEdit()"
                    *ngIf="options?.Footer?.ShowEdit"
                    style="padding: 0px; height: 40px; width: 40px;">
              <mat-icon style="margin-top: -4px; margin-left: -4px;">edit</mat-icon>
            </button>
          </div>

          <div class="col" style="padding: 0px; text-align: right;">
            <button
              mat-icon-button
              (click)="onCancel('Cancel')"
              mat-dialog-close
              *ngIf="options?.Footer?.ShowCancel !== false"
              style="padding: 0px; height: 40px; width: 40px;"
            >
              <mat-icon color="warn" style="margin-top: -4px; margin-left: -4px;">close</mat-icon>
            </button>
          </div>

          <div
            class="
              d-flex
              justify-content-end
            "
            [ngClass]="{
              'col-7': options?.Footer?.ShowOk,
              'col-12': !options?.Footer?.ShowOk
            }"
            style="padding: 0px;"
          >
              <!-- <ng-content select="[footer]"></ng-content> -->
              <ng-content select="[footer]" id="footer"></ng-content>
          </div>
        </div>

      <!-- </div> -->
    </div>
  </div>
</div>

<ng-container *ngIf="options?.VisibleMini">
  <div
    [ngClass]="{
      '': options?.PositionMini,
      'box-min': options?.PositionMini == 'left',
      'box-min-pw': options?.PositionMini == 'right'
    }"
    *ngIf="options?.isMinimized"
    (click)="onCancel('Maximize')"
  >
    <div class="maximize">
      <mat-icon>check_box_outline_blank</mat-icon>
    </div>
    <h3 class="mat-h3">
      <mat-icon>{{ options?.Header?.Icon }} </mat-icon>
      {{ options?.Header?.Title }}
    </h3>
  </div>
</ng-container>
